// extracted by mini-css-extract-plugin
export default {"Root":"FiltersInfos_Root__Vg9G0","Group":"FiltersInfos_Group__kVYlM"};